import React from 'react';
import { useFormContext } from 'react-hook-form';
import Button from '@common/button';

import { NCC_SUPPORT_EMAIL } from '@domain/constant/contact';
import classnames from 'classnames/bind';
import styles from './savePage.module.scss';

const cx = classnames.bind(styles);

interface SavePageProps {
  isLoading: boolean;
}

const SavePage = ({ isLoading }: SavePageProps) => {
  const { register } = useFormContext();

  return (
    <div className={cx('savePageArea')}>
      <div className={cx('logo')}>
        <span className={cx('hidden')}>JOBDA</span>
      </div>

      <div className={cx('infoArea')}>
        <em className={cx('title')}>잡다에 역검 응시 결과를 저장합니다.</em>

        <p className={cx('desc')}>
          역검 결과 별칭은 최대 20글자까지 입력할 수 있어요.
          <br />
          작성한 별칭은 결과 관리용으로 본인만 확인할 수 있어요.
        </p>

        <input
          {...register('name')}
          type="text"
          className={cx('input')}
          placeholder="역검 응시 결과 (기본값)"
          maxLength={20}
        />

        <Button className={cx('btn')} type={'submit'} isLoading={isLoading}>
          잡다에 결과 저장하기
        </Button>

        <p className={cx('notice')}>
          진행 중 문제가 발생할 경우{' '}
          <a href={NCC_SUPPORT_EMAIL} className={cx('link')} target="_blank">
            {NCC_SUPPORT_EMAIL}
          </a>
          로 문의해주세요.
        </p>
      </div>
    </div>
  );
};

export default SavePage;
